import { render, staticRenderFns } from "./inviteFriendsDlg.vue?vue&type=template&id=6568ebb6&scoped=true"
import script from "./inviteFriendsDlg.vue?vue&type=script&lang=js"
export * from "./inviteFriendsDlg.vue?vue&type=script&lang=js"
import style0 from "./inviteFriendsDlg.vue?vue&type=style&index=0&id=6568ebb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568ebb6",
  null
  
)

export default component.exports